<script>
import auth from "@/helpers/auth";

export default {
  beforeRouteEnter(to, from, next) {
    if (auth.signedIn()) {
      return next("/dashboard");
    } else {
      return next("/sign-in");
    }
  }
};
</script>
